import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import type { Entity, Module } from "@bios/types";
import { Card, EntityCard } from "@bios/ui";
import { useApiAuthed, useApiDev } from "../auth.js";

interface PageProps {
  devModeNoAuth?: boolean;
}

export function Entities({ devModeNoAuth }: PageProps) {
  const { module = "media" } = useParams<{ module: Module }>();
  const m = module as Module;
  const api = devModeNoAuth ? useApiDev() : useApiAuthed();
  const [entities, setEntities] = useState<Entity[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.entities(m).then((r) => setEntities(r.entities)).catch((e) => setError(String(e)));
  }, [api, m]);

  return (
    <>
      <div className="bios-page-header">
        <div>
          <h1 className="bios-page-title">Entities</h1>
          <p className="bios-page-sub">Entities driving real activity in this ecosystem.</p>
        </div>
      </div>
      {error && (
        <Card>
          <p style={{ color: "var(--bios-noise)", fontSize: 13 }}>{error}</p>
        </Card>
      )}
      {entities.length === 0 ? (
        <Card>
          <p className="bios-empty">No entities surfaced yet.</p>
        </Card>
      ) : (
        <div className="bios-grid cols-3">
          {entities.map((e) => (
            <EntityCard key={e.id} entity={e} />
          ))}
        </div>
      )}
    </>
  );
}
